import axios from "axios";
import { logout } from "../lib/auth";
import { saleCompanyTableColumn } from "../config/saleCompany";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  パートナー一覧取得
export async function getSaleCompanys(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "saleCompanys";
    const params = makeParams(saleCompanyTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const saleCompanys: dataDifine[] = response.data.fetch_data;
    const countSaleCompanys: string = response.data.count_data;
    return { saleCompanys, countSaleCompanys };
  } catch (error) {
    // logout();
  }
}

// パートナー詳細取得
export async function getSaleCompany(id: string) {
  try {
    const path = "saleCompany";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string;
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: number | string;
    }[] = response.data.option_data;
    return { detail_data, option_data };
  } catch (error) {
    // logout();
    return { detail_data: {}, option_data: [] };
  }
}

// パートナー情報編集
export async function putSaleCompany(editData: EditDataDifine) {
  try {
    const path = "saleCompany";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// パートナー情報登録
export async function postSaleCompany(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "saleCompany";
    const bodys = addData;
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
